import Axios, {AxiosInstance, AxiosPromise} from 'axios';
import ApiService from './apiService';
import EcCommon from '../../../types/ec/ecCommon';
import PtClientList from '../../../types/ec/ecPtClientList';

export const CoachServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.apimUrl + 'enterprise-coach-api',
	headers: {
		'Ocp-Apim-Subscription-Key': window.lt.api.apimKey,
	},
});

export default class CoachService extends ApiService implements EcCommon.ICoachService {
	constructor() {
		super('coach-service', CoachServiceAxiosInstance);
	}

	public getClientList(partyId: number, ignoreLoading?: boolean): AxiosPromise<PtClientList.IClientSummary[]> {
		const config: object = {
			ignoreLoading,
		};

		return this.axiosInstance.get('/coach/' + partyId + '/clients', config);
	}

	public setClientConnection(coachPartyId: number, clientPartyId: number): AxiosPromise<PtClientList.ISetClientConnectionResponse> {
		const partyId: object = {
			clientPartyId,
		};

		return this.axiosInstance.post('/connections/coach/' + coachPartyId, partyId);
	}

	public getNotificationSummary(memberPartyId: number, coachPartyId: number, status: string): AxiosPromise<PtClientList.INotificationSummary> {
		return this.axiosInstance.get('/notificationsummary/to/' + coachPartyId + '/from/' + memberPartyId + '/status/' + status);
	}

	public updateClientStatus(client: PtClientList.IClientStatusUpdateRequest, coachPartyId: number): AxiosPromise<PtClientList.IClientStatusUpdateResponse> {
		return this.axiosInstance.put('/connections/coach/' + coachPartyId, client);
	}

	public getSSOForTrainerize(partyId: number, suppressError?: boolean): AxiosPromise<EcCommon.ITrainerizeToken> {
		const config: object = {
			suppressError,
		};

		return this.axiosInstance.post('/employee/' + partyId + '/source/Trainerize/token', {}, config);
	}

	public getSSOForTrainerizeForMember(partyId: number, suppressError?: boolean): AxiosPromise<EcCommon.ITrainerizeToken> {
		const config: object = {
			suppressError,
		};

		return this.axiosInstance.post('/member/' + partyId + '/source/Trainerize/token', {}, config);
	}

	public getClientUserIdInTrainerize(partyId: number): AxiosPromise<EcCommon.IClientUserId> {
		return this.axiosInstance.get('/client/' + partyId + '/source/Trainerize');
	}

	public getPrograms(partyId: number): AxiosPromise<PtClientList.IProgram[]> {
		return this.axiosInstance.get('/program/client/' + partyId);
	}

	public getProducts(partyId: number): AxiosPromise<PtClientList.IProduct[]> {
		return this.axiosInstance.get('/product/client/' + partyId);
	}

	public getProductSessionDetails(memberId: number, packageId: number): AxiosPromise<PtClientList.ISession[]> {
		return this.axiosInstance.get('/product/client/' + memberId + '/package/' + packageId);
	}

	public getTaskList(partyId: number): AxiosPromise<PtClientList.ITaskList[]> {
		return this.axiosInstance.get('/coach/' + partyId + '/tasks');
	}

	public setClientDisconnect(coachPartyId: number, clientPartyId: number, clubId: number): AxiosPromise<void> {
		const data = {
			clientPartyId,
			coachPartyId,
			clubId,
		};

		return this.axiosInstance.post('/connections/disconnect/member', data);
	}
}

export const coachService = new CoachService();
